// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/es6.object.get-own-property-names.js
// module id = 1181
// module chunks = 168707334958949